import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environments/environment';
import { stream } from '@app/_models/stream';
import { Observable } from 'rxjs';
import { university } from '@app/_models/university';
import { headervalue } from 'src/headervalue/header';

const httpOptions = {
  headers: new HttpHeaders(headervalue.headerWithJwt)
};

@Injectable({ providedIn: 'root' })

export class universityService {
  url: string;
  constructor(private http: HttpClient) { }
  
  getUniversityVerifierRequestList() {
    var temp = this.http.get<any>(`${environment.apiUrl}/universityVerifier/getUniversityVerifierRequestList`,httpOptions);
  return temp;
  }

  addNewRemark(formdata) {
    var temp = this.http.post<any>(`${environment.apiUrl}/universityVerifier/addNewRemark`,formdata,httpOptions);
  return temp;
  }


}